<template>
<div>
  <div class="row">
    <div class="col-md-12 intro">
      <h4>Extrato</h4>
      <span>Este extrato são das doações realizadas via cartões de crédito e boleto bancário. 
        Doações realizadas via PayPal você poderá visualiza-las através do respectivo painel do meio de pagamento.</span>
    </div>
    
    <div class="col-md-12 extract">
      <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{msg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
        {{successMsg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="row" v-if="project.PagarmeBalance && project.PagarmeTransfers">
        <div class="col-md-3">
          <span>Transferidos</span>
          <h5 class="transfered">{{getRealValue(project.PagarmeBalance.transferred.amount)}}</h5>
        </div>
        <div class="col-md-3">
          <span>Aguardando</span>
          <h5 class="waiting">{{getRealValue(project.PagarmeBalance.waiting_funds.amount)}}</h5>
        </div>
        <div class="col-md-3">
          <span>Disponível</span>
          <h5 class="available">{{getRealValue(project.PagarmeBalance.available.amount)}}</h5>
        </div>
        <div class="col-md-3">
          <button class="btn" v-on:click.stop.prevent="transferAmount()">Retirar doações</button>
          <small>Custo de transferência: R$ 3,67</small>
        </div>
      </div>

      <div class="row">
        <table class="donations table" v-if="project.PagarmeTransfers">
          <thead>
            <th>Data</th>
            <th>Nome</th>
            <th>Dados</th>
            <th>Valor</th>
            <th>Status</th>
          </thead>
          <tbody>
            <tr v-for="(d, k) in project.PagarmeTransfers" v-bind:key="k">
              <td>{{getDate(d.date_created)}}</td>
              <td>{{d.bank_account.legal_name}}</td>
              <th>
                {{"Cod. " + d.bank_account.bank_code + " Ag. " + d.bank_account.agencia 
                + " " + d.bank_account.agencia_dv + " Cc. " + d.bank_account.conta + "-" + d.bank_account.conta_dv}}
              </th>
              <th>{{getRealValue(d.amount)}}</th>
              <td>{{getStatus(d.status)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'

export default {
  name: 'ProjectExtract',
  props: ['project'],
  components: {
    
  },
  data(){
    return {
      msg: '',
      showMsg: false,
      successMsg: '',
      showSuccessMsg: false,
    }
  },
  created(){
    
  },
  methods: {
    transferAmount(){
      this.hideMessage();
      this.$emit('showloading');
      if(this.project.PagarmeBalance.available.amount > 0){
        this.$http.post(API.Projects.updateProject + this.project.ProjectId, 
        {page: 'pagarmeTransferAmount', amount: this.project.PagarmeBalance.available.amount,
         recipient_id: this.project.PagarmeAccount.receiverId}, {headers: auth.getHeaders()})
         .then((res) => {
           this.successMsg = 'Solicitação efetuada! Valor será creditado em prazo de até 2 dias úteis.';
           this.showSuccessMsg = true;
           this.$emit('hideloading');
         }, (err) => {
           console.log(err.body)
           this.msg = 'Não foi possível solicitar transferência. Saldo insuficiente ou transferência ainda não foi concluída.';
           this.showMsg = true;
           this.$emit('hideloading');
         })
      }else{
        alert('Não há valores disponíveis para transferência.');
      }
    },
    getDate(date){
      var newDate = new Date(date);
      return newDate.toLocaleDateString()
    },
    getStatus(status){
      if(status == 'transferred'){
        return 'Transferido';
      }
      if(status == 'failed'){
        return 'Falhou'
      }
    },
    getRealValue(value){
      value = value / 100;
      return Functions.numberToReal(value)
    },
    hideMessage(){
      this.showSuccessMsg = false;
      this.successMsg = '';
      this.showMsg = false;
      this.msg = '';
    }
  }
}
</script>

<style lang="scss" scoped>
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.extract{
  border: thin solid #ddd;
  border-radius: 5px;
  margin-top: 20px;
  padding: 10px;
  span{
    font-size: 20px;
    color: #777;
  }
  h5{
    font-size: 32px;
    font-family: RalewayBold;

    &.transfered{
      color: #69A8FC;
    }
    &.waiting{
      color: #f6a623;
    }
    &.available{
      color: #00ae39;
    }
  }
  .btn{
    background-color: #fff;
    border: thin solid #00ae39;
    color: #00ae39;
    width: 100%;
  }
  small{
    color: #777;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manage-project/Extract.vue